import React from 'react';
import styled from 'styled-components';

import { animated } from 'react-spring';
import { breakpoints } from '../../constants';

import { ComponentStageType } from '../../types';

import { Header } from '../Header';
import { DesktopOnly } from './DesktopOnly';

import { createMarkup } from '../../utils';
import { createEnterExitAnimation } from '../../transitions';

interface IProps {
    questionText: string;
    stage: ComponentStageType;
}

export const QuestionHeader: React.FC<IProps> = ({ questionText, stage }) => {
    const animationStyle = createEnterExitAnimation({
        stage,
    });

    return (
        <DesktopOnly style={{ ...animationStyle }}>
            <Header dangerouslySetInnerHTML={createMarkup(questionText)} />
        </DesktopOnly>
    );
};
